/**
 * Fetch recipes with pagination + search via AJAX
 * @param {Object} options
 * @param {string} options.search - Search keyword
 * @param {number} options.page   - Page number (default 1)
 * @returns {Promise<{recipes, total, page, per_page, has_more}|null>}
 */
export async function fetchRecipes({ search = '', page = 1 } = {}) {
	const formData = new FormData();
	formData.append('action', 'wpcore_get_recipes');
	formData.append('nonce', wpcore.nonce);
	formData.append('search', search);
	formData.append('page', page);

	try {
		const response = await fetch(wpcore.ajaxUrl, {
			method: 'POST',
			body: formData,
		});
		const data = await response.json();
		return data.success ? data.data : null;
	} catch (error) {
		console.error('Error fetching recipes:', error);
		return null;
	}
}

/**
 * Assign recipes to a stage field via AJAX
 * @param {string} stageId    - Stage post ID
 * @param {string} fieldName  - ACF field name (e.g., day_1_recipes)
 * @param {Array}  recipeIds  - Array of recipe IDs
 * @returns {Promise<boolean>}
 */
export async function assignRecipes(stageId, fieldName, recipeIds) {
	const formData = new FormData();
	formData.append('action', 'wpcore_assign_recipes_to_stage');
	formData.append('nonce', wpcore.nonce);
	formData.append('stage_id', stageId);
	formData.append('field_name', fieldName);

	recipeIds.forEach((id) => {
		formData.append('recipe_ids[]', id);
	});

	try {
		const response = await fetch(wpcore.ajaxUrl, {
			method: 'POST',
			body: formData,
		});
		const data = await response.json();

		if (!data.success) {
			console.error('Error:', data.data?.message);
		}

		return data.success;
	} catch (error) {
		console.error('Error:', error);
		return false;
	}
}

/**
 * Fetch stage menu recipes for a specific day via AJAX
 * @param {string} stageId - Stage post ID
 * @param {number} day     - Day number (1-7)
 * @returns {Promise<Array>}
 */
export async function fetchStageMenuByDay(stageId, day) {
	const formData = new FormData();
	formData.append('action', 'wpcore_get_stage_menu_recipes');
	formData.append('nonce', wpcore.nonce);
	formData.append('stage_id', stageId);
	formData.append('day', day);

	try {
		const response = await fetch(wpcore.ajaxUrl, {
			method: 'POST',
			body: formData,
		});
		const data = await response.json();

		if (data.success) {
			return data.data.categories || [];
		}
		return [];
	} catch (error) {
		console.error('Error:', error);
		return [];
	}
}
